const data = {
    surveyQuestions: {
        isFetching: false,
        isError: false,
        status: '',
        result: [],
        error: '',
    },
    IdbindRetailers: {
        isFetching: true,
        isError: false,
        status: '',
        result: [],
        error: '',
    },
    userCredentials: {
        userData: {},
        profileData: {},
        isCredentialStateUpdated: false,
    },
    userAllData: {
        userData: {},
        profileData: {},
        isCredentialStateUpdated: false,
    },
    SamplingCampaignCheck: {
        userFromCampaignFlag: false,
    },
    LotteryCampaignCheck: {
        userFromLotteryFlag: false,
    },
    survey: {
        currentQuestion: 0,
        maxQuestion: 13,
        questions: {},
        answers: {},
        error: false,
    },
    productCategories: {},
    articleCategories: {},
    allPages: {},
};

export default data;
